import { Api } from "../api/Api";
import { useErrorWebhook } from "./useErrorWebhook";

export const useUkcStatus = () => {
  const { ErrorWebhookTrigger } = useErrorWebhook();
  
  const updateUkcStatus = async (
    uuid,
    status,
    response,
    ukcGuid = null,
    source = "live"
  ) => {
    const payload = {
      uuid,
      status,
      response,
      source
    };
    
    // Add ukcGuid to payload if provided
    if (ukcGuid) {
      payload.ukcGuid = ukcGuid;
    }
    
    const apiResponse = await Api.post("api/v1/ukc_status_update", payload).catch(function (error) {
      const errorMessage = {
        serviceName: 'UKC STATUS UPDATE',
        errorReason: error.message,
        errorCode: error.code,
        uuid: uuid
      }
      ErrorWebhookTrigger(errorMessage);
    });
    return apiResponse;
  };

  return { updateUkcStatus };
};
